import { axios, getToken, URL_API } from "../../../../../../../utils";

const getHeaders = () => ({ Authorization: "Bearer " + getToken() });

/**
 * Fetch conversation notes for a given partner
 * @param {string} partnerCode
 * @param {number} page
 * @param {number} limit
 */
export const getConversationNoteApi = async (
  partnerCode,
  page = 1,
  limit = 50,
  search = "",
) => {
  const response = await axios({
    url: `${URL_API}/crm/conversation-note`,
    headers: getHeaders(),
    method: "get",
    params: {
      partner_code: partnerCode,
      page,
      limit,
      search: search || undefined,
    },
  });
  return response.data?.data;
};

/**
 * Create a new conversation note
 * @param {object} payload
 */
export const createConversationNoteApi = async (payload) => {
  const response = await axios({
    url: `${URL_API}/crm/conversation-note`,
    headers: getHeaders(),
    method: "post",
    data: payload,
  });
  return response.data?.data;
};

/**
 * Fetch partner purchase overview + last order items
 * @param {string} partnerCode
 */
export const getOverviewApi = async (partnerCode, partnerType) => {
  const response = await axios({
    url: `${URL_API}/crm/overview/${partnerCode}`,
    headers: getHeaders(),
    method: "get",
    params: {
      partner_type: partnerType,
    },
  });
  return response.data?.data;
};

/**
 * Fetch lead source options from master data
 */
export const getLeadSourceOptionsApi = async () => {
  const response = await axios({
    url: `${URL_API}/crm/lead-source`,
    headers: getHeaders(),
    method: "get",
  });
  return response.data?.data;
};

/**
 * Update lead source for a partner
 * @param {string} partnerCode
 * @param {string} partnerType
 * @param {string} leadSourceValue
 */
export const updateLeadSourceApi = async (
  partnerCode,
  partnerType,
  leadSourceValue,
) => {
  const response = await axios({
    url: `${URL_API}/crm/lead-source/${partnerCode}`,
    headers: getHeaders(),
    method: "post",
    data: {
      partner_type: partnerType,
      lead_source_value: leadSourceValue,
    },
  });
  return response.data?.data;
};
